import theme, { colors } from '../../config/theme'

export default {
  h2: {
    color: colors.text,
    fontFamily: theme.p.fontFamily,
    fontSize: theme.h2.fontSize,
    lineHeight: theme.h2.lineHeight,
    fontWeight: theme.h2.fontWeight,
    height: theme.h2.height
  }
}



// WEBPACK FOOTER //
// ./src/components/H2/style.js